import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDisabledIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5,
	stroke: "currentColor",
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 6,
			cy: 11,
			r: 3
		}),
		/* @__PURE__ */ _jsx("path", { d: "M4 6.5L5.5 4.5L8.5 4M8.5 4L8.54253 4.04253C9.12081 4.62081 9.28876 5.4929 8.96661 6.24458L8 8.5M8.5 4L7 8" }),
		/* @__PURE__ */ _jsx("path", { d: "M9 10H11.5L12.5 13" }),
		/* @__PURE__ */ _jsx("circle", {
			cx: 10.75,
			cy: 2.25,
			r: .75
		})
	]
});
export default SvgDisabledIcon;
